import { defineComponent as t, openBlock as n, createBlock as r, unref as m, mergeProps as l, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as A } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconKeyboard",
  __name: "IconKeyboard",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(h) {
    const o = h;
    return (d, a) => (n(), r(m(A), l(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...a[0] || (a[0] = [
        e("path", { d: "M4.75 9A.75.75 0 0 1 5.5 8.25h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 4.75 9m12 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 16.75 9m-4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 12.75 9m-4 0A.75.75 0 0 1 9.5 8.25h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 8.75 9m-4 3a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 4.75 12m12 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 16.75 12m-4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 12.75 12M9.5 11.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1M4.75 15a.75.75 0 0 1 .75-.75h1a.75.75 0 1 1 0 1.5h-1A.75.75 0 0 1 4.75 15m12 0a.75.75 0 0 1 .75-.75h1a.75.75 0 1 1 0 1.5h-1A.75.75 0 0 1 16.75 15m-8 0a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5A.75.75 0 0 1 8.75 15" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M4.5 5.25A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25h15a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-15M3.75 7.5A.75.75 0 0 1 4.5 6.75h15a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75v-9",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
